'use strict';

import {addClass, removeClass, fadeIn, fadeOut} from '../helpers';

export const homeTop = (() => {
  let _title;
  let str;
  let dataFirst;
  let dataSecond;
  let prevF;
  let linePos = 0;
  let lineWidth = 0;

  const getUnicRandomWord = (arr, prev) => {
    const res = arr[Math.floor(Math.random() * arr.length)];
    if (res === prev) {
      return getUnicRandomWord(arr, prev);
    }

    return res
  };

  const getFirstLine = () => {
    prevF = getUnicRandomWord(dataFirst, prevF);
    const words = prevF.split('');
    let line = '#';
    for (let i = 0, l = words.length; i < l; i++) {
      line += `<span class="tit_top_one for-print" style="display:none">${words[i]}</span>`;
    }

    return line;
  };

  const getSecondLine = () => {
    let line = '<span class="tit_bot_line">';
    for (let i = 0; i < dataSecond.length; i++) {
      line += `<span class="tit_bot_line_one">${dataSecond[i]}</span>`
    }
    line += '</span>';

    return line;
  };

  const setTitle = () => {
    const wW = window.innerWidth;
    const prevText = str.replace('[first]', ``).replace('[second]', '').replace(' ', '');
    const firstHtml = getFirstLine();
    // const secondHtml = getSecondLine();

    const tmp = `<span class="tit_top">${prevText} <span class="tit_top_first">${firstHtml}</span></span>`
    _title.insertAdjacentHTML('afterbegin', tmp);

    setTimeout(() => {
      // lineWidth = Math.round(document.querySelector('.tit_bot_line:first-child').clientWidth * 100) / 100;
      // linePos = -lineWidth;
      // runLine(wW);
      printWord();
    }, 5);
  };

  const printWord = function () {
    const _wordForPrint = document.querySelectorAll('.tit_top_one.for-print')[0];
    let _hideWord = document.querySelectorAll('.tit_top_one:not(.hide)');
    _hideWord = _hideWord[_hideWord.length-1];
    if (_wordForPrint) {
      removeClass(document.querySelectorAll('.tit_top_one'), 'cursor');
      fadeIn(_wordForPrint, 80);
      setTimeout(() => {
        const delay = Math.floor(3 + Math.random() * 9) * 25; // from 75 to 300 | step: 25
        removeClass(_wordForPrint, 'for-print');
        addClass(_wordForPrint, 'cursor');
        setTimeout(printWord, delay);
      }, 80);
    } else if (_hideWord) {
      const delay = (!document.querySelectorAll('.tit_top_one.hide').length) ? 4000 : 0;
      setTimeout(() => {
        fadeOut(_hideWord, 60);
        setTimeout(() => {
          addClass(_hideWord, 'hide');
          setTimeout(printWord, 40);
        }, 60);
      }, delay);
    } else {
      if (document.querySelector('.tit_top_first')) {
        document.querySelector('.tit_top_first').innerHTML = getFirstLine();
        setTimeout(printWord, 500);
      }
    }
  };

  const runLine = function (winW) {
    window.shApp.homeRequestAnimation = requestAnimationFrame(() => runLine(winW));

    linePos = linePos - winW * 0.0012;
    if (linePos < -lineWidth * 2) {
      linePos = -lineWidth;
    }
    // animLine(linePos);
  };
  const animLine = (x) => {
    const lines = document.querySelectorAll('.tit_bot_second');
    lines.forEach(line => {
      line.style["transform"] = `translateX(${x}px) translateZ(0)`;
      line.style["webkitTransform"] = `translateX(${x}px) translateZ(0)`;
      line.style["mozTransform"] = `translateX(${x}px) translateZ(0)`;
      line.style["msTransform"] = `translateX(${x}px) translateZ(0)`;
    });
  };

  const eventListeners = function () {
    window.addEventListener("resize", function() {
      setTimeout(() => {
        lineWidth = Math.round(document.querySelector('.tit_bot_line:first-child').clientWidth * 100) / 100;
        linePos = -lineWidth;
      }, 5);
    })
  };

  const init = () => {
    if (window.shApp.homeRequestAnimation) {
      cancelAnimationFrame(window.shApp.homeRequestAnimation);
    }
    _title = document.querySelector('.home_top__title');
    if (!_title) {
      return false;
    }

    str = _title.getAttribute('data-str');
    dataFirst = _title.getAttribute('data-first').split(',');
    // dataSecond = _title.getAttribute('data-second').split(',');
    setTitle();
    addClass(document.querySelector('.home_top'), 'is-loading');

    // eventListeners();
  };

  return {
    init
  }
})();
